<template>
  <a href="#" id="scroll-top" class="scroll">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
    >
      <path
        d="M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"
      ></path>
    </svg>
  </a>
</template>

<script>
export default {};
</script>

<style scoped>
.scroll {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 15px;
  right: 15px;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  z-index: 20;
  cursor: pointer;
  box-shadow: 0 0 10px var(--first-color);
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.scroll:hover {
  box-shadow: 0 0 5px var(--first-color);
}

.scroll svg {
  fill: var(--first-color);
  transition: 0.2s;
}

.show-scroll {
  opacity: 1;
  transform: translateY(0);
}
@media screen and (max-width: 900px) {
  .scroll {
    display: none;
    width: 30px;
    height: 30px;
    bottom: 8px;
    right: 8px;
  }
}
</style>
